__turbopack_context__.v({
  "author_name": "styles-module-scss-module__5SLqPW__author_name",
  "card": "styles-module-scss-module__5SLqPW__card",
  "card_content": "styles-module-scss-module__5SLqPW__card_content",
  "card_image": "styles-module-scss-module__5SLqPW__card_image",
  "heading": "styles-module-scss-module__5SLqPW__heading",
  "loading_placeholder": "styles-module-scss-module__5SLqPW__loading_placeholder",
});
